import React, { useEffect } from 'react'
import Routing from './Routing'
import AuthHeader from './components/AuthHeader/AuthHeader'
import AdminHeader from './components/AdminHeader/AdminHeader'
import AdminRouting from './AdminRouting'
import CallCenterRouting from './RoutingCallCenter'

import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import CallAgentHeader from './components/CallAgentHeader/CallAgentHeader'

const RoutingLayout = () => {
  const location = useLocation();
  const _user = JSON.parse(localStorage.getItem("user"));
  const user = _user?.user

  let userRole = user?.role

  return (
    <div>
      {
        (["IVR_USER", "IVR_FACILITATOR"].includes(userRole)) &&
        <div>
          <AuthHeader />
          <Routing />
        </div>
      }
      {
        ["IVR_ADMIN", "IVR_ADMIN_ASSISTANT"].includes(userRole) &&
        <div>
          <AdminHeader />
          <AdminRouting />
        </div>

      }
      {
        (["CALL_CENTER_AGENT"].includes(userRole)) &&
        <div>
          {/* <AuthHeader /> */}
          <CallAgentHeader />
          <CallCenterRouting />
        </div>
      }

      {/* <AdminHeader>
        <AdminRouting />
      </AdminHeader> */}


    </div>
  )
}

export default RoutingLayout